import { render, staticRenderFns } from "./ErrorScreen.vue?vue&type=template&id=7ac37442&scoped=true&"
import script from "./ErrorScreen.vue?vue&type=script&lang=js&"
export * from "./ErrorScreen.vue?vue&type=script&lang=js&"
import style0 from "./ErrorScreen.vue?vue&type=style&index=0&id=7ac37442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac37442",
  null
  
)

export default component.exports